import "@src/styles/style.scss"
import React from "react"
import { StoreProvider } from "./src/components/StoreContext"

export const wrapRootElement = ({ element }) => {
  return <StoreProvider>{element}</StoreProvider>
}
